export const ARCGIS_CONSTANTS = {
    SERVICE_TYPES: {
        IDENTITY: 'identity',
        FEATURE_SERVICE: 'Feature Service',
        WEB_MAP: 'Web Map',
        MAP_SERVICE: 'Map Service',
    },
    PBF: {
        FORMAT: 'pbf',
        RESULT_TYPE_TILE: 'tile',
        SPATIAL_REL_INTERSECTS: 'esriSpatialRelIntersects',
        GEOMETRY_TYPE_ENVELOPE: 'esriGeometryEnvelope',
    },
    QUERY_DEFAULTS: {
        WHERE_ALL: '1=1',
        OUT_FIELDS_ALL: '*',
        RETURN_GEOMETRY_TRUE: 'true',
        RETURN_COUNT_ONLY_TRUE: 'true',
    },
    SPATIAL_REFERENCE: {
        WEB_MERCATOR: '3857',
        WEB_MERCATOR_WKID: 3857,
    },
    QUANTIZATION: {
        MODE_VIEW: 'view',
        ORIGIN_UPPER_LEFT: 'upperLeft',
    },
    STYLE_CACHE_KEYS: {
        DEFAULT: 'default',
        SIMPLE: 'simple',
        UNIQUE_VALUE_PREFIX: 'uv_',
        CLASS_BREAKS_PREFIX: 'cb_',
        CLASS_BREAKS_DEFAULT: 'cb_default',
        FALLBACK: 'fallback',
    },
    FETCH_STRATEGY: {
        SIMPLE: 'simple',
        PBF_TILED: 'pbf-tiled',
        JSON_THROTTLED: 'json-throttled',
    } as const,
    FETCH_THRESHOLDS: {
        SIMPLE_FETCH_MAX: 2000,
        PREFER_PBF_MIN: 2000,
    },
    CONCURRENCY: {
        PBF_TILES: 4,
        JSON_CHUNKS: 4,
        CHUNK_SIZE: 2000,
    },
    GRID_SIZES: {
        SMALL: 2,
        MEDIUM: 3,
        LARGE: 4,
        XLARGE: 5,
    },
    ASSET_TYPES: {
        FEATURE_SERVICE: 'feature-service',
        WEB_MAP: 'web-map',
        MAP_SERVICE: 'map-service',
    } as const,
    ASSET_TYPE_LABELS: {
        FEATURE_SERVICE: 'Feature Service',
        WEB_MAP: 'Web Map',
        MAP_SERVICE: 'Map Service',
    },
    ACCESS_LEVELS: {
        PUBLIC: 'public',
        ORG: 'org',
        SHARED: 'shared',
        PRIVATE: 'private',
    },
    CONTENT_STATUS: {
        PUBLIC_AUTHORITATIVE: 'public_authoritative',
        ORG_AUTHORITATIVE: 'org_authoritative',
    },
    DEFAULT_PORTAL_URL: 'https://www.arcgis.com',
    OAUTH_ENDPOINTS: {
        TOKEN: '/sharing/rest/oauth2/token',
        AUTHORIZE: '/sharing/rest/oauth2/authorize',
        SELF: '/sharing/rest/community/self',
        PORTALS_SELF: '/sharing/rest/portals/self',
        CONTENT_USERS: '/sharing/rest/content/users',
    },
    AGOL_ENDPOINTS: {
        REST_INFO: '/rest/info',
        VALIDATE_REDIRECT_URI: '/sharing/rest/oauth2/validateRedirectUri',
    },
    OAUTH_PARAMS: {
        CLIENT_ID: 'client_id',
        GRANT_TYPE: 'grant_type',
        CODE: 'code',
        REDIRECT_URI: 'redirect_uri',
        CODE_VERIFIER: 'code_verifier',
        CODE_CHALLENGE: 'code_challenge',
        CODE_CHALLENGE_METHOD: 'code_challenge_method',
        RESPONSE_TYPE: 'response_type',
        REFRESH_TOKEN: 'refresh_token',
        EXPIRATION: 'expiration',
        ACCOUNT_ID: 'accountId',
    },
    GRANT_TYPES: {
        AUTHORIZATION_CODE: 'authorization_code',
        REFRESH_TOKEN: 'refresh_token',
    },
    CODE_CHALLENGE_METHOD: 'S256',
    ROUTES: {
        LOGIN_RESPONSE: '/arcgis-login-response',
    },
    API_PATHS: {
        TOKEN: '/token',
    },
    QUERY_PARAMS: {
        ENTERPRISE_URL: 'enterpriseUrl',
        ENTERPRISE_APP_ID: 'enterpriseAppId',
        TOKEN: 'token',
        FORMAT: 'f',
        CUSTOMER_ID: 'cid',
    },
    FORMAT: {
        JSON: 'json',
    },
    ERROR_CODES: {
        TOKEN_REQUIRED: 499,
        INVALID_TOKEN: 498,
        FORBIDDEN: 403,
    },
    ABORT_ERROR: {
        NAME: 'AbortError',
        MESSAGE_ABORTED: 'Aborted',
        MESSAGE_SESSION_INVALIDATED: 'Session invalidated',
    },
    AGOL_CLIENT_ID: 'arcgisonline',
    AGOL_TOKEN_EXPIRATION: 20160,
} as const;

export function normalizePortalUrl(url: string | null | undefined): string {
    if (!url || !url.trim()) {
        return ARCGIS_CONSTANTS.DEFAULT_PORTAL_URL;
    }

    const trimmedUrl = url.trim();

    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
        return trimmedUrl;
    }

    return 'https://' + trimmedUrl;
}
